import Nullstack from 'nullstack';
export default function IconBedOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-bed-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 7v11"
  }), "   ", Nullstack.element("path", {
    d: "M3 14h11"
  }), "   ", Nullstack.element("path", {
    d: "M18 14h3"
  }), "   ", Nullstack.element("path", {
    d: "M21 18v-8a2 2 0 0 0 -2 -2h-7"
  }), "   ", Nullstack.element("path", {
    d: "M11 11v3"
  }), "   ", Nullstack.element("circle", {
    cx: "7",
    cy: "10",
    r: "1"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}